import React from 'react';
import { Link } from 'react-router-dom';
import Icon from './Icon';
import Reveal from './Reveal';
import { serviceArea } from '../data/site';

const ServiceArea = () => (
  <section className="border-t border-ink-700 py-24">
    <div className="container-site grid items-center gap-12 lg:grid-cols-[1.2fr_1fr]">
      <Reveal>
        <p className="eyebrow">Moncton · New Brunswick · Atlantic Canada</p>
        <h2 className="mt-4 font-display text-3xl font-bold text-white md:text-4xl">
          Based in Moncton, working across Atlantic Canada.
        </h2>
        <p className="mt-6 leading-relaxed text-slate-400">
          Gomagen Labs is a local partner for businesses in Greater Moncton and throughout New Brunswick, Nova Scotia,
          Prince Edward Island, and Newfoundland and Labrador. We're happy to meet in person around Moncton, and we
          work remotely with clients across the region.
        </p>
        <Link to="/contact" className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-signal-400 hover:text-signal-300">
          Talk to us about your project <Icon name="arrow" className="h-4 w-4" />
        </Link>
      </Reveal>

      <Reveal delay={0.1} className="card p-8">
        <h3 className="flex items-center gap-2 font-display font-semibold text-white">
          <Icon name="pin" className="h-5 w-5 text-signal-400" /> Where we work
        </h3>
        <ul className="mt-6 flex flex-wrap gap-2">
          {serviceArea.map((place) => (
            <li key={place} className="rounded-full border border-ink-600 px-3.5 py-1.5 text-sm text-slate-300">
              {place}
            </li>
          ))}
        </ul>
        <p className="mt-6 text-sm text-slate-500">And anywhere in Atlantic Canada, on-site or remote.</p>
      </Reveal>
    </div>
  </section>
);

export default ServiceArea;
